import { render, staticRenderFns } from "./dotresultResults.vue?vue&type=template&id=f176f5da&scoped=true&"
import script from "./dotresultResults.vue?vue&type=script&lang=js&"
export * from "./dotresultResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f176f5da",
  null
  
)

export default component.exports